import packageJson from '../../package.json';
import { FirebaseOptions } from '@firebase/app';

export const environment = {
  prodMode: true,
  version: packageJson.version, // TODO We should directly inject the version here instead of via package.json
  newFirebase: {
    apiKey: 'AIzaSyDRj3e9Ek4Tb2Qq0gd_jfi_AQJXOqimKJs',
    authDomain: 'mateco-planning.firebaseapp.com',
    projectId: 'mateco-planning',
    storageBucket: 'mateco-planning.firebasestorage.app',
    messagingSenderId: '693364531467',
    appId: '1:693364531467:web:00c4fc07b1304d08ce020e'
  } as FirebaseOptions
};
